import { render } from "./PlansFbwaComponent.vue?vue&type=template&id=42f86a6c&scoped=true"
import script from "./PlansFbwaComponent.vue?vue&type=script&lang=js"
export * from "./PlansFbwaComponent.vue?vue&type=script&lang=js"

import "./PlansFbwaComponent.vue?vue&type=style&index=0&id=42f86a6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42f86a6c"]])

export default __exports__